import { useSuspenseQuery } from '@apollo/client';
import { Button } from '../../../../components/Button/Button';
import { useModal } from '../../../../components/Modal/PresentedModal';
import { graphql } from '../../../../generated';
import { ReactElement } from 'react';
import React from 'react';
import { t } from '../../../../locales/translate';
import { formatNumber } from '../../../../util/formatters';
import { mapContainingOnly, mapOrderStatus, mapPaymentMethods } from '../../../../model/param_mappings';

const ORDER_COUNT = graphql(`
  query OrderCount(
    $during: TimeRangeInput
    $term: String
    $status: [OrderStatus!]
    $storageLocationIds: [ID!]
    $paymentMethodIds: [PaymentMethod!]
    $containingOnly: ContainingOnly
    $withShippableProductsOnly: Boolean
  ) {
    statistics {
      orderCount(
        during: $during
        term: $term
        status: $status
        storageLocationIds: $storageLocationIds
        paymentMethodIds: $paymentMethodIds
        containingOnly: $containingOnly
        withShippableProductsOnly: $withShippableProductsOnly
      )
    }
  }
`);

interface Props {
  timeframe?: {
    from?: Date;
    to?: Date;
  };
  status?: string[];
  term?: string;
  storageLocationIds?: string[];
  paymentMethodIds?: string[];
  containingOnly?: string;
  withShippableProductsOnly?: boolean;
}

export function OrderCount({
  timeframe,
  status = [],
  term,
  storageLocationIds,
  paymentMethodIds = [],
  containingOnly,
  withShippableProductsOnly,
}: Props): ReactElement {
  const { open, Modal, size, close } = useModal();

  const { data } = useSuspenseQuery(ORDER_COUNT, {
    variables: {
      status: mapOrderStatus(status),
      paymentMethodIds: mapPaymentMethods(paymentMethodIds),
      containingOnly: containingOnly ? mapContainingOnly(containingOnly) : undefined,
      during: timeframe,
      term,
      storageLocationIds,
      withShippableProductsOnly,
    },
  });

  return (
    <Modal
      open={open}
      size={size}
      title={t.model.order.ordersCount}
      footer={<Button title={t.model.order.close} onClick={close} />}
    >
      {formatNumber(data?.statistics?.orderCount, 0)}
    </Modal>
  );
}
